import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  DialogContent,
  IconButton,
  Dialog as MuiDialog,
  Typography,
} from "@mui/material";
import { FC } from "react";

import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";

import formSentImg from "web/assets/images/formSent.svg";

import classes from "./successModal.scss";

interface ISuccessModalProps {
  open: boolean;
  onClose: () => void;
  isMobile?: boolean;
}

const SuccessModal: FC<ISuccessModalProps> = ({
  open,
  onClose,
  isMobile = false,
}) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          padding: 0,
          boxShadow: {
            xs: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            md: "0px 1px 0px 0px #BDBDBD",
          },
          margin: { xs: "15.5px", md: "32px" },
        },
      }}
    >
      {" "}
      <IconButton
        aria-label={__("Zamknij modal")}
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "grey.600",
          zIndex: 100,
        }}
      >
        <CloseIcon height={24} width={24} />
      </IconButton>
      <DialogContent
        sx={{
          backgroundColor: "#E8F5F5",
          px: { xs: "16px", md: "18px" },
          pt: { xs: "52px", md: "64px" },
          pb: { xs: "32px", md: "41px" },
          maxWidth: { md: "513px" },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src={formSentImg}
            width={isMobile ? 168.5 : 176}
            alt=""
          />
        </Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: { xs: 700, md: 800 },
            fontSize: { xs: "20px", md: "24px" },
            lineHeight: { xs: "27px", md: "130%" },
            marginBottom: { xs: 1, md: 2 },
            marginTop: 2,
            textAlign: "center",
          }}
        >
          {__("Dziękujemy za wysłanie zgłoszenia")}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "17px",
            lineHeight: "150%",
            marginBottom: { xs: "4px", md: "16px" },
            textAlign: "center",
          }}
        >
          {__("Odpowiemy na nie najszybciej jak to będzie możliwe.")}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="tertiary"
            onClick={onClose}
            className={classes.button}
          >
            {__("Zamknij")}
          </Button>
        </Box>
      </DialogContent>
    </MuiDialog>
  );
};

export default SuccessModal;
